import type { AggregateResultField, AggregatorGroupStatisticsConfig } from '@lighthouse/shared'
import { nanoid } from '@lighthouse/tools'
import React, { useCallback, useMemo } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import * as SC from '../styles'
import { AddButton } from './AddButton'
import { StatisticsFieldItem } from './StatisticsFieldItem'

interface StatisticsFieldConfigProps {
    fieldList: AggregateResultField[]
}

export const StatisticsFieldConfig: React.FC<StatisticsFieldConfigProps> = ({ fieldList }) => {
    const { control } = useFormContext<AggregatorGroupStatisticsConfig>()
    const { fields, append, remove, move } = useFieldArray({
        control,
        keyName: 'fieldId',
        name: 'statisticsFields'
    })

    const handleClick = useCallback(() => {
        const id = `f${nanoid(10)}`
        append({
            fieldId: id,
            statisticsFieldId: '',
            name: '',
            calcType: ''
        })
    }, [append])

    const handleRemove = useCallback(
        (i: number) => {
            remove(i)
        },
        [remove]
    )

    const content = useMemo(() => {
        if (fields.length === 0) {
            return null
        }
        return (
            <SC.ConfigureContent>
                {fields.map((item, index) => (
                    <StatisticsFieldItem
                        key={item.fieldId}
                        fieldList={fieldList}
                        prefixName={`statisticsFields.${index}`}
                        onRemove={() => handleRemove(index)}
                    />
                ))}
            </SC.ConfigureContent>
        )
    }, [fieldList, fields, handleRemove])

    return (
        <SC.FormItem>
            <SC.FormItemLabelWrapper>
                <SC.FormItemLabel>统计字段</SC.FormItemLabel>
            </SC.FormItemLabelWrapper>
            <SC.FormItemContent>
                {content}
                <AddButton onClick={handleClick} />
            </SC.FormItemContent>
        </SC.FormItem>
    )
}
